import { lazy } from "react";

const HallIndex = lazy(() => import("../pages/booking/hall"));
const SelectHall = lazy(() => import("../pages/booking/hall/SelectHall"));
const StepHopeDate = lazy(() => import("../pages/booking/hall/StepHopeDate"));
const StepVisitor = lazy(() => import("../pages/booking/hall/StepVisitor"));
const StepVisitDate = lazy(() => import("../pages/booking/hall/StepVisitDate"));
const StepCustomerInfo = lazy(() => import("../pages/booking/hall/StepCustomerInfo"));
const Complete = lazy(() => import("@src/pages/booking/hall/Complete"));
const SelectHallSearch = lazy(() => import("@src/pages/booking/hall/SelectHallSearch"));
const SelectHallRegionResult = lazy(() => import("@src/pages/booking/hall/SelectHallRegionResult"));

const SelectBranch = lazy(() => import("@src/pages/booking/homeAppliance/SelectBranch"));
const HomeApplianceApply = lazy(() => import("@src/pages/booking/homeAppliance/Apply"));
const HomeApplianceComplete = lazy(() => import("@src/pages/booking/homeAppliance/Complete"));

const StepHopeDateAdditional1 = lazy(() => import("@src/pages/booking/hall/StepHopeDateAdditional1"));
const StepHopeDateAdditional2 = lazy(() => import("@src/pages/booking/hall/StepHopeDateAdditional2"));
const StepVisitorAdditional1 = lazy(() => import("@src/pages/booking/hall/StepVisitorAdditional1"));
const StepVisitDateAdditional1 = lazy(() => import("@src/pages/booking/hall/StepVisitDateAdditional1"));

const BookingManagementList = lazy(() => import("@src/pages/booking/management/List"));
const BookingManagementChat = lazy(() => import("@src/pages/booking/management/Chat"));
const HallManagement = lazy(() => import("@src/pages/booking/hall/Management"));
const HallCancel = lazy(() => import("@src/pages/booking/hall/Cancel"));
const HallChange = lazy(() => import("@src/pages/booking/hall/Change"));
const VisitDate = lazy(() => import("@src/pages/booking/weddinghall/VisitDate"));
const InterestHallSelect = lazy(() => import("@src/pages/weddingHall/compare/HallCompareSelect"));

export const bookingRoutes = [
  // 웨딩홀 예약 관련 경로
  { path: "/booking/hall", element: <HallIndex /> },
  { path: "/booking/hall/select", element: <SelectHall /> },
  { path: "/booking/hall/hope-date", element: <StepHopeDate /> },
  // { path: "/booking/hall/hope-date/additional/1", element: <StepHopeDateAdditional1 /> },
  // { path: "/booking/hall/hope-date/additional/2", element: <StepHopeDateAdditional2 /> },
  { path: "/booking/hall/visitor", element: <StepVisitor /> },
  // { path: "/booking/hall/visitor/additional/1", element: <StepVisitorAdditional1 /> },
  { path: "/booking/hall/visit-date", element: <StepVisitDate /> },
  { path: "/booking/hall/visit-date/additional/1", element: <StepVisitDateAdditional1 /> },
  { path: "/booking/hall/customer-info", element: <StepCustomerInfo /> },
  { path: "/booking/hall/complete", element: <Complete /> },
  { path: "/booking/hall/date", element: <VisitDate /> }, // 일반, 즉시예약 통합
  { path: "/booking/hall/interest", element: <InterestHallSelect /> }, // 위시리스트 -> 방문예약
  { path: "/booking/hall/search-filter", element: <SelectHallSearch /> }, // 견적요청 웨딩홀 검색페이지
  { path: "/booking/hall/search-region", element: <SelectHallRegionResult /> }, // 견적요청 웨딩홀 지역 검색페이지
  // 가전 예약 관련 경로
  { path: "/booking/homeAppliance/select-branch", element: <SelectBranch /> },
  { path: "/booking/homeAppliance/apply", element: <HomeApplianceApply /> },
  { path: "/booking/homeAppliance/complete", element: <HomeApplianceComplete /> },

  // 예약 관리 관련 경로
  { path: "/booking/management/list", element: <BookingManagementList /> },
  { path: "/booking/management/chat", element: <BookingManagementChat /> },
  { path: "/booking/hall/management", element: <HallManagement /> },
  { path: "/booking/hall/cancel/:uuid", element: <HallCancel /> },
  { path: "/booking/hall/change/:uuid", element: <HallChange /> },
];